import type { PropsWithChildren } from 'react';
import { VpButton, VpIconButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';

export const ShareButton = ({
  children,
  disabled = false,
  iconAlone = false,
  onClick,
}: PropsWithChildren<{
  disabled?: boolean;
  iconAlone?: boolean;
  onClick: () => void;
}>) => {
  const t = useTranslations('INTERACTION');

  return iconAlone
    ? (
        <VpIconButton
          variant="secondary"
          aria-label={t('SHARE_SOCIAL_NETWORK')}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </VpIconButton>
      )
    : (
        <VpButton
          variant="tertiary"
          startSlot={children}
          onClick={onClick}
          disabled={disabled}
        >
          {t('SHARE_SOCIAL_NETWORK')}
        </VpButton>
      );
};
